import { useState, useEffect, useCallback } from 'react';
import { Grid, Button, Drawer, useTheme, useMediaQuery } from '@mui/material';
import FiltersBtnIcon from '@shared/assets/FiltersBtnIcon';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

import useFlightFilters from '@shared/hooks/useFlightFilters';
import FiltersSkeleton from './FiltersSkeleton';
import FilterContent from './FilterContent';
import { sxStyled } from './styles';

const FlightFilters = ({
  filters,
  optimizedClusters,
  flightResultFiltered,
  setFlightResultFiltered,
  optimizedCustomClusters,
  flightsCustomDta,
  isCustomSearch,
  setNoResultsInTheFilter,
  tabButton,
  setIsFiltering,
}) => {
  const theme = useTheme();
  const sxStyle = sxStyled(theme);
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));
  const [open, setOpen] = useState(false);

  const flightFilters = useFlightFilters({
    initialFilters: filters,
    optimizedClusters,
    flightResultFiltered,
    setFlightResultFiltered,
    optimizedCustomClusters,
    flightsCustomDta,
    isCustomSearch,
    setNoResultsInTheFilter,
    setIsFiltering,
  });

  const handleCloseDrawer = useCallback(() => setOpen(false), []);
  const handleOpenDrawer = useCallback(() => setOpen(true), []);

  useEffect(() => {
    flightFilters.handleClearFilters();
  }, [tabButton]);

  if (isCustomSearch && optimizedCustomClusters.length === 0) {
    return <FiltersSkeleton />;
  }

  if (isDesktop) {
    return (
      <FilterContent
        flightFilters={flightFilters}
        sxStyle={sxStyle}
        theme={theme}
        isDesktop={isDesktop}
      />
    );
  }

  return (
    <>
      {!open && (
        <Grid sx={sxStyle.filterButtonContainer}>
          <Button
            variant="contained"
            sx={sxStyle.filterButtonMobile}
            onClick={handleOpenDrawer}
            startIcon={<FiltersBtnIcon color={theme.text1} />}
          >
            Filtros
          </Button>
        </Grid>
      )}

      <Drawer
        anchor="right"
        open={open}
        onClose={handleCloseDrawer}
        PaperProps={{ sx: { width: '100%', maxWidth: 360 } }}
      >
        <FilterContent
          flightFilters={flightFilters}
          sxStyle={sxStyle}
          theme={theme}
          isDesktop={isDesktop}
          drawerMode
          handleCloseDrawer={handleCloseDrawer}
        />
      </Drawer>

      {scrollY > 2000 && (
        <Grid sx={sxStyle.filterButtonUpContainer}>
          <Button
            sx={sxStyle.buttonUpMobile}
            onClick={() => window.scrollTo(0, 0)}
          >
            <ExpandLessIcon />
          </Button>
        </Grid>
      )}
    </>
  );
};

export default FlightFilters;
